import React, { ReactNode, useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getsession, getTaskDetails } from "../utils/apis";
import { KEY_AUTH_DETAILS, KEY_BILLINGCITY, KEY_LANG, KEY_STORE_ID } from "../utils/contants";
import { AuthContext } from "../context/AuthContext";
import { useTranslation } from "react-i18next";


const AuthWrapper: React.FC<{ children: ReactNode; adjustHeight?: boolean }> = ({
  children,
  adjustHeight,
}) => {
  const location = useLocation();
  const navigate = useNavigate();

  const authContext = useContext(AuthContext);
  const { i18n } = useTranslation();

  const [loading, setLoading] = useState(true);
  const [authenticated, setAuthenticated] = useState(false);

  useEffect(() => {
    const queryParams = new URLSearchParams(location.search);
    const query = queryParams.get("query");
    const taskId = queryParams.get("task_id");
    const clientHeight = queryParams.get("clientHeight");

    // Adjust page height if provided
    if (clientHeight) {
      document.documentElement.style.minHeight = `${clientHeight}px`;
      document.body.style.minHeight = `${clientHeight}px`;
    }

    // Only trigger getsession once using localStorage flag
    if (localStorage.getItem("sessionDone") === "true") {
      setLoading(false);
      setAuthenticated(!!(localStorage.getItem("token") || authContext?.token));
      return;
    }

    const sessionParam = query || taskId;
    if (!sessionParam) {
      const token = localStorage.getItem("token") || authContext?.token;
      setAuthenticated(!!token);
      setLoading(false);
      return;
    }

    const latitudeStored = localStorage.getItem("latitude");
    const longitudeStored = localStorage.getItem("longitude");

    const fetchSession = async () => {
      try {
        const result = await getsession(
          sessionParam,
          undefined,
          latitudeStored || undefined,
          longitudeStored || undefined
        );

        console.log("Session result:", result);

        const { token, data } = result;
        const accId = data?.User?.Contact?.AccountId;
        const contactId = data?.User?.ContactId;
        const city = data?.User?.Contact?.Account?.BillingAddress?.city;
        const dte_acc_id = data?.User?.Contact?.Account?.DTE_Account_Id__c;
        const lang = data?.User?.LanguageLocaleKey;

        if (city) {
          window.parent.postMessage({ action: "storeToLocal", label: city }, "*");
        }

        if (token && accId) {
          authContext?.setSession(token);
          localStorage.setItem(KEY_AUTH_DETAILS, accId);
          if (lang) localStorage.setItem(KEY_LANG, lang);
          if (city) localStorage.setItem(KEY_BILLINGCITY, city);
          if (dte_acc_id) localStorage.setItem(KEY_STORE_ID, dte_acc_id);
          if (lang) i18n.changeLanguage(lang);

          const taskRes = await getTaskDetails(contactId);
          if (taskRes.data && taskRes.data.length > 0) {
            setAuthenticated(true);
            console.log("Task Details:", taskRes.data);
          } else {
            navigate("/tasks");
          }

          // Mark session as done to prevent multiple calls
          localStorage.setItem("sessionDone", "true");
        } else {
          setAuthenticated(false);
        }
      } catch (err) {
        console.error("Session Error:", err);
        setAuthenticated(false);
      } finally {
        setLoading(false);
      }
    };

    fetchSession();
  }, [location.search]);

  return (
    <>
      {loading ? (
        <div>Authenticating....</div>
      ) : authenticated ? (
        <div style={{ height: adjustHeight ? "calc(100vh - 254px)" : "auto" }}>
          {children}
        </div>
      ) : (
        <div>Unauthenticated</div>
      )}
    </>
  );
};

export default AuthWrapper;

